import type { WithingsOrderPostContentObjectDetail, WithingsOrderPostContentObjectList } from 'models';
import { useMutation } from 'query';
import { deleteOrderPost } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeleteOrderPostContentObject = {
  contentObject: WithingsOrderPostContentObjectDetail | WithingsOrderPostContentObjectList;
};

export const useDeleteOrderPostContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeleteOrderPostContentObject, DeleteOrderPostContentObject>({
    async mutationFn(object) {
      await deleteOrderPost({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
